import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public rooms: any[] = [];
    public selectedRoom: any = null;
    public loading: boolean = true;
    private today: string = this.toDateKey(new Date());

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.setDefaults();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200 && data) {
            this.today = data.today || this.today;
            this.rooms = this.withTodayReservations(data.rooms || this.rooms);
        }

        this.loading = false;
        await this.service.render();
    }

    public async openRoom(group: any, space: any, event?: Event) {
        this.stopEvent(event);
        this.selectedRoom = {
            floor: group.floor,
            ...space,
            reservations: this.todayReservations(space.reservations || [])
        };
        await this.renderNextTick();
    }

    public async closeRoom(event?: Event) {
        this.stopEvent(event);
        this.selectedRoom = null;
        await this.renderNextTick();
    }

    public namesText(names: string[] | null | undefined) {
        if (!names || names.length === 0) return '없음';
        return names.join(', ');
    }

    private withTodayReservations(rooms: any[]) {
        return rooms.map((group: any) => {
            return {
                ...group,
                spaces: (group.spaces || []).map((space: any) => {
                    const reservations = this.todayReservations(space.reservations || []);
                    const cardReservation = this.cardReservation(space, reservations);

                    return {
                        ...space,
                        attendees: space.attendees || cardReservation?.attendees || [],
                        externalAttendees: space.externalAttendees || cardReservation?.externalAttendees || [],
                        reservations
                    };
                })
            };
        });
    }

    private cardReservation(space: any, reservations: any[]) {
        if (!reservations.length) return null;

        if (space.time) {
            const reservation = reservations.find((item: any) => {
                return item.time === space.time || `${item.start}-${item.end}` === space.time;
            });
            if (reservation) return reservation;
        }

        if (space.status && !String(space.status).includes('비어')) return reservations[0];
        return null;
    }

    private todayReservations(reservations: any[]) {
        return reservations
            .filter((reservation: any) => !reservation.date || reservation.date === this.today)
            .sort((left: any, right: any) => this.reservationStart(left).localeCompare(this.reservationStart(right)));
    }

    private reservationStart(reservation: any) {
        if (reservation.start) return reservation.start;
        if (reservation.time) return String(reservation.time).split('-')[0];
        return '';
    }

    private stopEvent(event?: Event) {
        if (!event) return;
        event.preventDefault();
        event.stopPropagation();
    }

    private async renderNextTick() {
        await this.service.sleep(0);
        await this.service.render();
    }

    private toDateKey(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private setDefaults() {
        this.rooms = [
            {
                floor: '505호',
                description: '대표실, 회의실',
                spaces: [
                    {
                        name: '대표실',
                        status: '외부 사용 중',
                        usage: '외부 미팅',
                        time: '13:00-14:00',
                        cardClass: 'border-emerald-200 bg-emerald-50',
                        dotClass: 'bg-emerald-500',
                        statusClass: 'bg-emerald-100 text-emerald-700',
                        reservations: [
                            { date: this.today, start: '13:00', end: '14:00', time: '13:00-14:00', title: '외부 미팅', host: '대표', type: '외부', attendees: ['대표', '정초롱', '영업팀 김민수'], externalAttendees: ['Acme 김하늘', 'Acme 박준서'], badgeClass: 'bg-emerald-100 text-emerald-700' },
                            { date: this.today, start: '16:00', end: '17:00', time: '16:00-17:00', title: '파트너 계약 논의', host: '정초롱', type: '외부', attendees: ['정초롱', '사업팀 이다은'], externalAttendees: ['파트너사 이수진', '파트너사 장민호'], badgeClass: 'bg-emerald-100 text-emerald-700' }
                        ]
                    },
                    {
                        name: '회의실',
                        status: '비어 있음',
                        usage: '예약 없음',
                        time: '즉시 사용 가능',
                        cardClass: 'border-gray-200 bg-gray-50',
                        dotClass: 'bg-gray-400',
                        statusClass: 'bg-gray-100 text-gray-600',
                        reservations: [
                            { date: this.today, start: '15:00', end: '15:30', time: '15:00-15:30', title: '운영 점검', host: '관리자', type: '내부', attendees: ['관리자', '시설팀 박지훈'], externalAttendees: [], badgeClass: 'bg-amber-100 text-amber-700' }
                        ]
                    }
                ]
            },
            {
                floor: '503호',
                description: '회의실, 세미나실',
                spaces: [
                    {
                        name: '회의실',
                        status: '내부 사용 중',
                        usage: '내부 회의',
                        time: '13:30-14:30',
                        cardClass: 'border-amber-200 bg-amber-50',
                        dotClass: 'bg-amber-500',
                        statusClass: 'bg-amber-100 text-amber-700',
                        reservations: [
                            { date: this.today, start: '10:00', end: '11:00', time: '10:00-11:00', title: '제품 주간 회의', host: '제품팀', type: '내부', attendees: ['제품팀', '개발팀 이서연', '디자인팀 최민재'], externalAttendees: [], badgeClass: 'bg-amber-100 text-amber-700' },
                            { date: this.today, start: '13:30', end: '14:30', time: '13:30-14:30', title: '내부 회의', host: '운영팀', type: '내부', attendees: ['운영팀', '정초롱', 'CS팀 한유진'], externalAttendees: [], badgeClass: 'bg-amber-100 text-amber-700' }
                        ]
                    },
                    {
                        name: '세미나실',
                        status: '비어 있음',
                        usage: '예약 없음',
                        time: '즉시 사용 가능',
                        cardClass: 'border-gray-200 bg-gray-50',
                        dotClass: 'bg-gray-400',
                        statusClass: 'bg-gray-100 text-gray-600',
                        reservations: []
                    }
                ]
            }
        ];
    }
}

export default PageDashboardComponent;